import { render, staticRenderFns } from "./UserConfiguration.vue?vue&type=template&id=40c61559&scoped=true"
import script from "./UserConfiguration.ts?vue&type=script&lang=ts&external"
export * from "./UserConfiguration.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c61559",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c61559')) {
      api.createRecord('40c61559', component.options)
    } else {
      api.reload('40c61559', component.options)
    }
    module.hot.accept("./UserConfiguration.vue?vue&type=template&id=40c61559&scoped=true", function () {
      api.rerender('40c61559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/User/pages/UserConfiguration/UserConfiguration.vue"
export default component.exports